var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.597,
    height: 19.12,
    viewBox: "0 0 34.597 19.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#53b5e0;}.b{fill:#f8fdff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1064 -421)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1064 421)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M54.872,42.664c-.311-.352-7.7-8.974-17.08-8.974s-16.77,8.622-17.08,8.974a.873.873,0,0,0,0,1.137c.311.387,7.7,9.009,17.08,9.009s16.77-8.622,17.08-8.974A.873.873,0,0,0,54.872,42.664Z",
    transform: "translate(-20.501 -33.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M46.536,41.63a4.906,4.906,0,1,0,4.906,4.906h0A4.918,4.918,0,0,0,46.536,41.63Z",
    transform: "translate(-29.245 -36.976)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeHover);
export default __webpack_public_path__ + "static/media/eye-hover.6f0b19cd5cf90b32bc7dd7ad4c3701f9.svg";
export { ForwardRef as ReactComponent };